import React from 'react';
import { Button } from '@/components/ui';
import { ShieldAlert, Home, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PermissionDeniedStateProps {
  module?: string;
  action?: string;
  title?: string;
  message?: string;
}

/**
 * PermissionDeniedState - Giao diện chặn trang chuyên nghiệp
 * Hiển thị khi người dùng truy cập Route không được phép
 */
export const PermissionDeniedState: React.FC<PermissionDeniedStateProps> = ({
  module,
  action,
  title = 'Truy cập bị từ chối',
  message = 'Bạn không có đủ thẩm quyền để truy cập tính năng này. Vui lòng liên hệ quản trị viên để được cấp quyền.',
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center animate-in fade-in zoom-in duration-300">
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-red-100 rounded-full blur-2xl opacity-50 animate-pulse" />
        <div className="relative bg-white p-6 rounded-full shadow-xl border border-red-50">
          <ShieldAlert className="w-16 h-16 text-red-500" />
        </div>
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2">
        {title}
      </h1>
      
      <p className="text-gray-500 max-w-md mb-8 sm:text-sm text-xs">
        {message}
        {module && (
          <span className="block mt-2 font-mono text-xs bg-gray-100 p-1 rounded">
            Mã định danh: {module}{action ? `.${action}` : ''}
          </span>
        )}
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button 
          variant="outline" 
          onClick={() => navigate(-1)}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Quay lại
        </Button>
        
        <Button 
          onClick={() => navigate('/')}
          className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700"
        >
          <Home className="w-4 h-4" />
          Trang chủ
        </Button>
      </div>
    </div>
  );
};
